const key = "add-translations";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const modify = (resp) => {
	resp.data.Data = {
		...resp.data.Data,
		Translations: {
			...resp.data.Data.Translations,
			"en-us": {
				"report": "ticket"
			}
		}
	};

	resp.data.Data.Agency.Types[0].Translations = {
		"en-us": {
			"name": "paul"
		}
	};

	return resp;
};

export const addTranslations = [key, applicable, modify];